export default __webpack_public_path__ + "static/media/icon_checked.8606f932.svg";